import styled from "styled-components";
import { Flex } from "antd";

export const StyledFlex = styled(Flex)`
  height: 70vh;
`;
